import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Seo from "@/components/Seo";
import Hero from "@/sections/Hero";
import Concept from "@/sections/Concept";
import AppMobile from "@/sections/AppMobile";
import Features from "@/sections/Features";
import Reseau from "@/sections/Reseau";
import Events from "@/sections/Events";
import Pricing from "@/sections/Pricing";
import Parrainage from "@/sections/Parrainage";
import Partners from "@/sections/Partners";
import Stats from "@/sections/Stats";
import Testimonials from "@/sections/Testimonials";
import Gallery from "@/sections/Gallery";
import JoinBanner from "@/components/JoinBanner";
import { scrollToId } from "@/lib/lenis";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      const t = setTimeout(() => scrollToId(id), 250);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <main>
      <Seo
        title="Business Club Vaucluse & Avignon | Motards Business Club 84"
        description="Business club des entrepreneurs motards du Vaucluse : réseau professionnel, sorties moto, afterworks et événements entre Avignon, le Gard et le Sud-Est."
        path="/"
      />
      <Hero />
      <Concept />
      <AppMobile />
      <Features />
      <Reseau />
      <Events />
      <Pricing />
      <Parrainage />
      <Partners />
      <Stats />
      <Testimonials />
      <Gallery />
      <JoinBanner />
    </main>
  );
}
